// extracted by css-extract-rspack-plugin
export default {"itemLayout":"itemLayout-InBo_p","iconContainer":"iconContainer-EIOJsn","info":"info-s8l7Xg","extra":"extra-HoSfcP","preferred":"preferred-rsK6Uj"};